module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box citic-box"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleTabClicked
    },
    model: {
      value: (_vm.tabSelected),
      callback: function($$v) {
        _vm.tabSelected = $$v
      },
      expression: "tabSelected"
    }
  }, _vm._l((_vm.status), function(item) {
    return _c('el-tab-pane', {
      key: item.name,
      attrs: {
        "label": item.label,
        "name": item.name
      }
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("\n              " + _vm._s(item.label) + "\n              "), _c('sup', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.counter > 0),
        expression: "item.counter > 0"
      }]
    }, [_vm._v(_vm._s(item.counter))])]), _vm._v(" "), _c('ReviewList', {
      attrs: {
        "status": item.name,
        "is-activated": _vm.tabSelected === item.name
      }
    })], 1)
  }), 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-577f058c!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/posts/Home.vue
// module id = 460
// module chunks = 11